import { makeStyles } from 'tss-react/mui';
import { themeProps } from './theme';

const useStyles = makeStyles()((theme) => ({
  compareReport: {
    background: theme.palette.primary.main,
    height: '100%',
    width: '100%',
    overflow: 'auto',
    '@media print': {
      '& *': {
        color: `${themeProps.colors.black} !important`,
      },

      '& h1,& h2, & a': {
        color: `${themeProps.colors.cobalt} !important`,
      },

      '& span': {
        color: `${themeProps.colors.white} !important`,
      },

      '& td, & th, & li': {
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
      },
    },
  },
  main: {
    width: '80vw',
    margin: '0 auto',
    maxWidth: '800px',
    padding: '50px 0 2rem 0',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      margin: '0',
      padding: '70px 1rem 2rem 1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '50px',
    },
    '& aside': {
      fontSize: themeProps.textSize.h6,
    },
    '@media print': {
      width: '100% !important',
      padding: '0 !important',
      background: `${themeProps.colors.white} !important`,
    },
  },
  reportTitle: {
    marginTop: '30px',
    '@media print': {
      marginTop: '0 !important',
    },
  },
  header: {
    background: theme.palette.primary.dark,
    flex: '0 0 auto',
  },
  headerButton: {
    color: theme.palette.text.primary,
    marginLeft: '0.5rem',
    transition: 'all 0.3s',
    '&:hover': {
      background: theme.palette.text.primary,
      color: theme.palette.primary.main,
    },
    'headerButton > &': {
      borderBottom: '2px solid #fff',
    },
  },
  summaryTable: {
    width: '100%',
    '& td': {
      padding: '0.25rem 0.5rem',
    },
  },
  summaryTableBandCell: {
    minWidth: '10ch',
    textAlign: 'center',
    fontWeight: 'bold',
    color: themeProps.colors.white,

    '@media print': { color: `${themeProps.colors.white} !important` },
  },

  reportLogo: {
    display: 'none',
    '@media print': {
      display: 'block',
    },
  },

  page: {
    padding: '0 50px !important',
    pageBreakAfter: 'always',
  },
}));

export default useStyles;
